@if (status == 'loading') {
  <p-progress-bar class="progress-bar" mode="indeterminate" />
} @else if (status == 'success') {
  <i class="pi pi-check-circle" style="font-size: 2rem"></i>
  Signed In
} @else if (status == 'error') {
  <i class="pi pi-times-circle" style="font-size: 2rem"></i>
  <p style="padding: 1rem">
    <p-message size="small" severity="error">{{ errorMessage }}</p-message>
  </p>
}
